import { createRouter, createWebHistory } from 'vue-router'
import routes from "./routes";

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior() {
        document.getElementById('app').scrollIntoView();
    }
});

// authentication driver


const validateLogin = () => {
    try {
        var active = localStorage.getItem("cred");
        if (active == "active") {
            return true;
        }
    } catch (e) {
        return false;
    }
}

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        // this route requires auth, check if logged in
        // if not, redirect to login page.
        if (validateLogin()) {
            next({
                path: 'login',
                query: { redirect: to.fullPath }
            })
        } else {
            next()
        }
    } else {
        next() // make sure to always call next()!
    }
})

export default router
